import { render, staticRenderFns } from "./viewAnnouncementModal.vue?vue&type=template&id=ccd2eb64&scoped=true"
import script from "./viewAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./viewAnnouncementModal.vue?vue&type=script&lang=js"
import style0 from "./viewAnnouncementModal.vue?vue&type=style&index=0&id=ccd2eb64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd2eb64",
  null
  
)

export default component.exports